module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO ID_DESTAQUES-75c5e089178a06a92fca9923f999c6a3.png";